import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Utility from '../../../util/utilityfunctions';

function CanvasFormInputValue({className, isSnapshotView, value}) {
	return (
		<StyledCanvasFormInputValue className={`StyledCanvasFormInputValue ${className}`}>
			{Utility.getHtmlTextElement(value, isSnapshotView, false)}
		</StyledCanvasFormInputValue>
	);
}

CanvasFormInputValue.propTypes = {
	className: PropTypes.string,
	isSnapshotView: PropTypes.bool,
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

CanvasFormInputValue.defaultProps = {
	className: 'canvas-form-input-value',
	isSnapshotView: false
};

export default CanvasFormInputValue;

const StyledCanvasFormInputValue = styled.section`
	display: inline;
	padding: var(--px-15) var(--px-5) var(--px-5) var(--px-5);
	height: unset;
`;
